// extracted by mini-css-extract-plugin
export default {"root":"cRmGIjoL","mobile":"LiN0zJaf"};